














import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import userManager from "@/services/userManager";
import BlurredTenant from '@/components/BlurredTenant.vue';

export default Vue.extend({
    components: { BlurredTenant },
    async created() {
        await this.initializeFiltersFromQuery();

        // Handle userId from route query parameter
        const $route = this.$route;
        console.log($route.query);

        if ($route.query.userId) {
            this.selectedUserId = $route.query.userId;
        }
    },
    methods: {
        async initializeFiltersFromQuery() {
            const { userId, membershipId } = this.$route.query;
            if (userId || membershipId) {
                // Wait for next tick to ensure component is mounted
                await this.$nextTick();
                const dataTable = this.$refs.dataTable;
                if (dataTable && dataTable.setFilterValues) {
                    const filters: any = {};
                    if (userId) { filters.userId = userId; this.selectedUserId = userId; }
                    if (membershipId) { filters.membershipId = membershipId; }
                    dataTable.setFilterValues(filters);
                }
            }
        },
    },
    data() {
        const userId = this.$route.query.userId;
        console.log(userId);
        return {
            showBlur: userManager.checkRole(["cpoAdmin", "cpoMonitor"], true) && !!userManager.getUserInfo().tenant?.setting?.expDate && userManager.getUserInfo().tenant.setting.expDate < new Date().getTime(),
            self: this,
            selectedTenant: null,
            selectedUserId: null,
            tableOptions: {
                attrs: {
                    "item-key": "_id",
                    "sort-by": "usageDate",
                    "sort-desc": true,
                },
                content: {
                    name: "Charging Membership Usage History",
                    search: {
                    },
                    filters: {
                        filters: {

                            usageDate: {
                                type: "XDateTimePicker",
                                rules: {
                                    greater_than_or_equal_to: {
                                        attrs: {
                                            label: "Usage Date (From)",
                                        },
                                    },
                                    less_than_or_equal_to: {
                                        attrs: {
                                            label: "Usage Date (To)",
                                        },
                                    },
                                },
                            },
                        },
                    },
                    displayFields: {
                        sessionId: {
                            text: "Session ID",
                            options: {
                                label: true,
                            },
                        },
                        stationName: {
                            text: "Charging Station",
                            options: {
                                subProp: "session.chargingStationSnapshot.uniqueId",
                                label: true,
                            },
                        },
                        consumptionKWh: {
                            text: "Consumption (kWh)",
                            options: {
                                transform: (value) => {
                                    return parseFloat(value || 0).toFixed(2);
                                },
                                label: true,
                            },
                        },
                        savedAmount: {
                            text: "Saved Amount (VND)",
                            options: {
                                transform: (value) => {
                                    return new Intl.NumberFormat('vi-VN', {
                                        style: 'currency',
                                        currency: 'VND'
                                    }).format(value || 0);
                                },
                                label: true,
                            },
                        },
                        usageDate: {
                            text: "Usage Date",
                            options: {
                                transform: (data) => {
                                    return new Date(data).toLocaleString("en-GB");
                                },
                            },
                        },
                    },
                    topActionButtons: {
                    },
                },
                ext: {
                    dataProvider: {
                        async findAll(options) {

                            if ((this.selectedUserId || userId) && !options.filters?.userId) {
                                options.payload = JSON.parse(options.payload);
                                options.payload.filters.push({
                                    key: "userId",
                                    operator: "equal_to",
                                    value: this.selectedUserId || userId,
                                });
                                options.payload = JSON.stringify(options.payload);
                            }
                            console.log("Options received in findAll:", options);
                            const { items, count } = await coreApiClient.callRaw("chargingMemberships", "getUsageHistory", options);
                            return [items, count];
                        },
                    },
                },
            },
        };
    },
});
